module.exports = __webpack_public_path__ + "img/collection-engagementRingsPrincess@2x.ef95aa8.webp";